export default {
    namespaced: true,
    state: {
      approvalNotice: false,
    },
    getters: {
  
  
  
    },
    mutations: {
      SET_APPROVAL_STATE(state, value) {
        state.approvalNotice = value
      },
    },
    actions: {
        
    },
  }